const frenchPageData = {
  slug: 'french',
  code: 'fr',
  name: 'French',
  nativeName: 'Français',
  flag: '🇫🇷',
  accent: 'from-blue-500 to-violet-600',
  description: 'Summary notes and quick references for French learners.',
  notes: { summary: [], keyPoints: [], quickReference: [] },
};

export default frenchPageData;
